import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const visitPage = createAction('visitCentralizedDispatchPage');
export const setTripsOrderFields = createAction('setCentralizedDispatchTripsOrderFields');
export const setTripsSearchCriteria = createAction('setCentralizedDispatchTripsSearchCriteria');
export const setDriversSearchCriteria = createAction('setCentralizedDispatchDriversSearchCriteria');
export const getFilterSettingsSuccess = createAction('getCentralizedDispatchFilterSettingsSuccess');
export const getFilterSettingsRequest = createAction('getCentralizedDispatchFilterSettingsRequest');
export const saveFilterSettingsRequest = createAction('saveCentralizedDispatchFilterSettingsRequest');
export const deleteFilterSettingsRequest = createAction('deleteCentralizedDispatchFilterSettingsRequest');
export const updateFilterSettingsRequest = createAction('updateCentralizedDispatchFilterSettingsRequest');
export const setDriversRadiusRequestParams = createAction('setCentralizedDispatchDriversRadiusRequestParams');
